var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquiggledLogoBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-51.2,-51.2)",
    d: "M307.2,548.9894204854965C367.7913169128716,552.5764568105404,432.24614000271504,582.0086180382733,484.81590418662864,551.667319310616C538.5299833210395,520.6655648573044,571.1243359593934,456.17205096694556,575.2347868999163,394.2897815393726C579.0127020120883,337.4137929364822,522.618296341329,297.1400043464633,505.3304608557406,242.82351084426702C487.86741170251656,187.95651510900848,516.2405546176998,116.65401919484464,474.3094927817146,77.19351539613999C432.40521255015096,37.75821524257906,364.3361319628368,49.542285231774784,307.2,56.366801643371595C255.7100585283686,62.516919590345395,210.0776586205153,85.39186950650384,166.77822101409438,113.92600216340051C121.38713820981297,143.83851950255138,76.67479552138698,175.79405136639903,52.266230935717736,224.36699719612346C25.039995710976775,278.54709631981865,5.908005128685662,341.35620216544646,23.301432935257697,399.4442361716334C40.85250754850719,458.05875599585937,90.09852187285803,502.98893412885195,144.23313355216735,531.5046486146371C193.78362192012452,557.605650083018,251.29330066526242,545.6797158686553,307.2,548.9894204854965",
    fill: "#6B7D99",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD4446"
    },
    d: "M290.068,512.001c-9.426,0-17.067-7.642-17.067-17.067V329.486c0-9.426,7.642-17.067,17.067-17.067 s17.067,7.642,17.067,17.067v165.446C307.135,504.359,299.493,512.001,290.068,512.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD4446"
    },
    d: "M386.952,435.141c-29.849,0-54.134-24.285-54.134-54.135V246.603 c0-9.426,7.642-17.067,17.067-17.067s17.067,7.642,17.067,17.067v134.404c0,11.028,8.972,20,19.999,20s20-8.973,20-20v-62.567 c0-9.426,7.642-17.067,17.067-17.067h42.754c9.426,0,17.067,7.642,17.067,17.067s-7.642,17.067-17.067,17.067h-25.687v45.499 C441.087,410.855,416.801,435.141,386.952,435.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C74C4E"
    },
    d: "M327.778,218.495l-53.767-149.29c-6.03-16.742,14.64-30.478,27.717-18.247l105.787,98.968 c24.792,23.196,12.985,64.78-20.309,71.474l-40.007,8.043C338.868,231.116,330.633,226.424,327.778,218.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C74C4E"
    },
    d: "M221.932,512.001c-9.426,0-17.067-7.642-17.067-17.067V329.486c0-9.426,7.642-17.067,17.067-17.067 s17.067,7.642,17.067,17.067v165.446C238.999,504.359,231.359,512.001,221.932,512.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C74C4E"
    },
    d: "M125.049,435.141c-29.849,0-54.135-24.285-54.135-54.135v-45.5H45.227 c-9.426,0-17.067-7.642-17.067-17.067s7.642-17.067,17.067-17.067h42.754c9.426,0,17.067,7.642,17.067,17.067v62.566 c0,11.028,8.973,20,20,20s19.999-8.973,19.999-20V246.603c0-9.426,7.642-17.067,17.067-17.067s17.067,7.642,17.067,17.067v134.404 C179.183,410.855,154.898,435.141,125.049,435.141z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5153"
    },
    d: "M164.801,229.446l-40.006-8.043c-33.283-6.693-45.107-48.273-20.308-71.474l105.785-98.968 c12.99-12.151,33.786,1.397,27.717,18.247l-53.766,149.287C181.365,226.429,173.125,231.115,164.801,229.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC5B5D"
    },
    d: "M256,352.699c-28.247,0-56.493-10.42-78.504-31.264c-30.18-28.579-40.422-72.762-26.09-112.558 L216.69,27.61c13.265-36.829,65.367-36.798,78.62,0l65.284,181.266c14.333,39.797,4.092,83.979-26.09,112.559 C312.494,342.279,284.247,352.699,256,352.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5153"
    },
    d: "M360.595,208.876L295.311,27.611C288.683,9.21,272.342,0.003,256,0.001v352.698 c28.246,0,56.493-10.42,78.504-31.264C364.685,292.856,374.926,248.673,360.595,208.876z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C6466"
    },
    cx: 209.334,
    cy: 277.319,
    r: 22.578
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C6466"
    },
    cx: 302.669,
    cy: 277.319,
    r: 22.578
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggledLogoBlob);
export default __webpack_public_path__ + "static/media/squiggled-logo-blob.afb3fd8012589b439ed6bfcd30000774.svg";
export { ForwardRef as ReactComponent };